<template>
  <div class="sion-login-container login" v-loading.fullscreen.lock="loading">
    <div class="sion-login-logo">
      <img :src="'data:image/png;base64,'+hospitalInfo.src" alt v-if="hospitalInfo" />
      <img v-else src="@/images/logo.png" alt />
    </div>
    <div class="sion-login-signin">
      <cube-form :model="siginInfo">
        <cube-form-group>
          <div class="sign-box">
            <div class="sign-label">
              <label for>用户名</label>
            </div>
            <div class="sign-input">
              <cube-input v-model="siginInfo.username" placeholder="请输入手机号/身份证" @blur="input_blur"></cube-input>
            </div>
          </div>
          <p class="error-hint" v-if="siginInfo.userCheck">用户名输入错误</p>
        </cube-form-group>
        <cube-form-group>
          <div class="sign-box">
            <div class="sign-label">
              <label for>密码</label>
            </div>
            <div class="sign-input">
              <cube-input
                v-model="siginInfo.passward"
                type="password"
                :eye="eye"
                placeholder="请输入密码"
                @blur="input_blur"
              ></cube-input>
            </div>
          </div>
          <p class="error-hint" v-if="siginInfo.pwdCheck">用户名输入错误</p>
        </cube-form-group>
      </cube-form>
    </div>
    <cube-form-group class="forget">
      <span @click="forget">忘记密码</span>
    </cube-form-group>
    <cube-form-group>
      <cube-button :disabled="siginInfo.disabled" @click.prevent="signIn">登录</cube-button>
    </cube-form-group>
  </div>
</template>
<script type="text/ecmascript-6">
import { userLogin, updateStaffWechat, setCookie } from "@/common/api";
import { toast } from "@/common/api/api.js";
import { mapMutations } from "vuex";
import configUrl from '../../config/configUrl'
export default {
  data() {
    return {
      siginInfo: {
        username: "",
        userCheck: false,
        passward: "",
        pwdCheck: false,
        disabled: true
      },
      eye: {
        open: false,
        reverse: false
      },
      code: "",
      loading: "",
      baseInfo: {},
      hospitalInfo: {}
    };
  },
  mounted() {
    // if (this.$route.query.code) {
    //   localStorage.setItem("code", this.$route.query.code);
    //   this.code = this.$route.query.code;
    // }
    this.getLogo();
  },
  // beforeRouteLeave(to, from, next) {
  //   alert(100);
  //   alert(JSON.stringify(to.meta));
  //   alert(JSON.stringify(from.meta));
  //   // if (to.name === "login") {
  //   //   alert(200);
  //   //   next({ name: "personalCenter" });
  //   // } else {
  //   //   next(); // 注意：这边next必须要写
  //   // }
  // },
  created() {
    if (this.$route.query.code) {
      localStorage.setItem("code", this.$route.query.code);
      this.code = this.$route.query.code;
    } else {
      let appid = localStorage.getItem("appId"); // 西安服务器APPID
      // let redirect_uri = "http://wx.shx.logimis.com/login?appId=" + appid; // 西安服务器地址--测试
      // let redirect_uri = "http://wx.shxasset.logimis.com/login?appId=" + appid; // 西安服务器地址--开发
      // let redirect_uri = "https://wx.union.logimis.com/login?appId=" + appid;  // 西安服务器地址
      let redirect_uri = `${configUrl.redirectUri}login?appId=${appid}`;
      let status = "0";
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${status}#wechat_redirect`;
    }
  },
  watch: {
    siginInfo: {
      deep: true,
      handler: value => {
        if (value.passward && value.username) {
          value.disabled = false;
        }
      }
    }
  },

  methods: {
    ...mapMutations(["setLoginInfo", "changeLogin"]),
    forget() {
      console.log('忘记密码')
      this.$router.push("/forget");
    },
    getLogo() {
      let appId = localStorage.getItem("appId");
      let params = {
        appId,
        currentPage: 0
      };
      this.centralControl.axios.centralControl(
        "getActivityolSystemGallery",
        res => {
          const { data = [], code, message } = res;
          if (code == 200) {
            this.hospitalInfo = data && data[0];
            if (this.hospitalInfo)
              localStorage.setItem(
                "hospitalInfo",
                JSON.stringify(this.hospitalInfo)
              );
          } else {
            toast(this, message, "error");
          }
        },
        params
      );
    },
    signIn() {
      let IDReg = new RegExp(
        /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
      );
      let phoneReg = new RegExp(/^[1][3,4,5,7,8][0-9]{9}$/);
      if (
        IDReg.test(this.siginInfo.username) ||
        phoneReg.test(this.siginInfo.username)
      ) {
        //this.siginInfo.userCheck = true;
        this.loading = true;
        userLogin({
          username: this.siginInfo.username,
          password: this.siginInfo.passward,
          interfaceNum: "2"
        }).then(res => {
          if (res.code == 200) {
            this.$store.commit("changeLogin", "1");
            this.setLoginInfo(res.data);
            setCookie("sessionId", res.data.sessionId);
            sessionStorage.setItem("sessionId", res.data.sessionId);
            localStorage.setItem('loginToken','LoginUser ' + res.data.saToken)
            updateStaffWechat({
              code: this.code ? this.code : localStorage.getItem("code"),
              appId: localStorage.getItem("appId")
            }).then(res => {});
            this.$router.push("/homeZhyf");
            this.baseInfo = JSON.stringify(res.data);
            this.loading = false;
          } else {
            toast(this, res.message, "error");
            this.loading = false;
          }
        });
      } else {
        toast(this, "用户名格式不正确", "error");
      }
    },
    // h5 input输入框弹 键盘弹起再关掉，页面被顶起
    input_blur() {
      setTimeout(() => {
        let scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight, 0));
      }, 100);
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/index.styl';

.cube-form-group {
  margin-top: 0.8rem;
}

.cube-form-group .cube-btn {
  border-radius: 0.16rem;
  width: 90%;
  margin: 0 auto;
}

.error-hint {
  height: 22px;
  font-size: 12px;
  color: red;
  margin-top: 5px;
}

.login {
  .sign-input {
    width: 75%;

    .cube-input {
      width: 100%;
    }
  }
}

.forget {
  text-align: right;
  margin-top: 10px;
  margin-right: 20px;
  font-size: 14px;
  line-height 20px;
  > span{
    line-height 20px;
  }
}
</style>